import { useEffect, useRef, useState, createElement, forwardRef } from "react";
import './index.scss';
const ColorfulTextarea = forwardRef(({ label = '标题', placeholder = '输入文本', defaultValue, textAlign = 'left', required = false, separate = false, isHideLabel = false, disabled, labelWidth, limit, isError, onChange, ...otherProps }, ref) => {
    const areaClass = separate ? 'au-textarea-separate' : '';
    const alignClass = `au-textarea-${textAlign}`;
    const labelFixWidth = labelWidth ? `${labelWidth}px` : 'auto';
    const statusClass = isError ? 'au-textarea-error' : '';
    const areaRef = useRef(null);
    const _otherProps = otherProps || {};
    const [inputNum, setInputNum] = useState(0);
    const [inputValue, setInputValue] = useState(defaultValue);
    const handleChange = (e) => {
        const { value } = e.target;
        setInputValue(value);
        setInputNum(value?.length);
        if (onChange) {
            onChange(e);
        }
    };
    useEffect(() => {
        if (defaultValue?.length > 0) {
            setInputValue(defaultValue);
            setInputNum(defaultValue?.length);
        }
    }, [defaultValue]);
    return (createElement("div", { className: `au-textarea ${areaClass} ${alignClass} ${statusClass}`, ..._otherProps },
        createElement("div", { className: "area-part" },
            !isHideLabel && createElement("label", { className: 'inner-label', style: { width: labelFixWidth } },
                required ? createElement("span", { className: "required-title" }, "*") : '',
                label || '标题'),
            createElement("div", { className: 'area-content' },
                createElement("textarea", { className: 'inner-textarea', placeholder: placeholder || '输入文本', ref: ref || areaRef, value: inputValue, disabled: disabled, maxLength: limit || 1000, onChange: handleChange })),
            isError && createElement("i", { className: "icon-exclamation-circle" })),
        Boolean(limit) && createElement("div", { className: "limit-number" },
            createElement("label", { className: `limit-part ${disabled ? 'disabled-num' : ''}` },
                createElement("span", { className: `${limit ? 'active-num' : ''}` }, inputNum),
                " / ",
                createElement("span", null, limit)))));
});
ColorfulTextarea.displayName = 'ColorfulTextarea';
export default ColorfulTextarea;
